import React, { useEffect, useMemo, useState } from "react";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { createAppTheme } from "./theme";

export default function ThemeHotSwapProvider({ children }) {
  const [nonce, setNonce] = useState(0);

  useEffect(() => {
    const onUpdate = () => setNonce((n) => n + 1);
    window.addEventListener("theme-colors-updated", onUpdate);
    return () => window.removeEventListener("theme-colors-updated", onUpdate);
  }, []);

  const theme = useMemo(() => createAppTheme(), [nonce]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
